import { useI18n as useVueI18n } from "vue-i18n"

export const useI18n = () => {
  const { t, locale } = useVueI18n()

  const setLanguage = (lang: "pl" | "en") => {
    locale.value = lang
    localStorage.setItem("app_language", lang)
  }

  return {
    t,
    locale,
    setLanguage,
  }
}
